const optionsToAttributes = (optionsToUpdate, optionsFromNode, ignoredOptions = []) => {
  const attributesMap = optionsToUpdate.reduce((attributes, option) => {
    const { isSet, value, attribute, id, querySelector, userModified, index } = option;

    if (ignoredOptions.includes(id)) return attributes;
    if (!isSet) {
      return {
        ...attributes,
        [`${attribute}`]: {
          isSet,
          value,
          querySelector,
          userModified,
        },
      };
    }

    let compiledValue = value;
    const pairOptionFromOptions = optionsToUpdate.find(
      (item) => item.attribute === attribute && item.id !== id
    );
    const pairOptionFromNode = optionsFromNode.find(
      (item) => item.attribute === attribute && item.id !== id
    );

    const pairOption = pairOptionFromOptions || pairOptionFromNode;

    if (pairOption) {
      if (Number.isInteger(index) && index) {
        compiledValue = [pairOption.value, value].filter(Boolean).join(' ');
      } else {
        compiledValue = [value, pairOption.value].filter(Boolean).join(' ');
      }
    }

    return {
      ...attributes,
      [`${attribute}`]: {
        isSet,
        value: compiledValue,
        querySelector,
        userModified,
      },
    };
  }, {});

  const keys = Object.keys(attributesMap);
  return keys.map((key) => ({
    ...attributesMap[key],
    attribute: key,
  }));
};

export default optionsToAttributes;
